/*
 * Copyright © 2023 - Zimproov.
 * All rights reserved.
 */


export { getResource } from "./get-resource";
export { getResources } from "./get-resources";
